module.exports = __webpack_public_path__ + "img/credigo@2x.ef22e01.png";